import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { AnalyticsTable } from '../../../components/Analytics/AnalyticsTable';

/**
 * The zero-code report page: renders ANY registered analytics view by route param.
 * A future report reaches the panel with NO frontend change — expose the view in
 * api_admin's permission map, then create a Navigation record pointing at
 * /analytics/report/<view-name>. Columns, labels and formatting all come from
 * the catalog metadata via AnalyticsTable.
 */
export const AnalyticsReportPage = () => {
  const { view } = useParams<{ view: string }>();

  if (!view) return null;

  const title = view
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700} mb={3}>
        {title}
      </Typography>
      <AnalyticsTable view={view} />
    </Box>
  );
};
